module.exports = __webpack_public_path__ + "static/media/contact-banner.456ca3d3.svg";